class WhatsAppPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = parseInt(this.dataset.delay) * 1000 || 20000; // Default 20000ms (20s)
    this.reopenDays = parseInt(this.dataset.reopen) || 7; // Default 7 days
    this.sectionId = this.dataset.sectionId;

    this.overlay = this.querySelector('.whatsapp-modal__overlay');
    this.dismissLink = this.querySelector('.whatsapp-popup__dismiss');
    
    this.showPopupAfterDelay();
    this.initCustomEvents();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.show();
        }
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.hide();
        }
      });
    }
  }

  showPopupAfterDelay() {
    if (window.Shopify && window.Shopify.designMode) {
      // In Shopify Theme Editor, NEVER trigger the popup automatically via timer
      return;
    }

    const modalClosed = localStorage.getItem('whatsappPopupClosed');
    const currentTime = new Date().getTime();

    // Only show if not closed or close duration has expired
    if (!modalClosed || currentTime > parseInt(modalClosed)) {
      this.timer = setTimeout(() => {
        this.show();
      }, this.delay);
    }
  }

  initCustomEvents() {
    // Dismiss/close when overlay backdrop is clicked
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.hide();
      });
    }

    // Dismiss when text link is clicked
    if (this.dismissLink) {
      this.dismissLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.hide();
      });
    }

    // Capture CTA click (optionally can set a shorter cooldown or keep active)
    const ctaButton = this.querySelector('.whatsapp-popup__btn');
    if (ctaButton) {
      ctaButton.addEventListener('click', () => {
        // When they join, dismiss the modal and set longer cooldown so it won't bug them again
        const expirationDate = new Date().getTime() + 30 * 24 * 60 * 60 * 1000; // 30 days
        localStorage.setItem('whatsappPopupClosed', expirationDate);
        
        // Let it open link normally, then hide the modal
        setTimeout(() => {
          this.hide();
        }, 800);
      });
    }
  }

  hide() {
    super.hide();
    
    // Clear timer if user closes/leaves page before trigger
    if (this.timer) {
      clearTimeout(this.timer);
    }
    
    // Set localStorage dismissed date
    const expirationDate = new Date().getTime() + this.reopenDays * 24 * 60 * 60 * 1000;
    localStorage.setItem('whatsappPopupClosed', expirationDate);
  }
}

// Define the custom element
if (!customElements.get('whatsapp-popup')) {
  customElements.define('whatsapp-popup', WhatsAppPopup);
}
